/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Access_Conflicts_Section_UsersInputs */



/**
* | output |
* | --- |
* | "Users with Missing Access" |
*
* @param {Project_Access_Conflicts_Section_UsersInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_access_conflicts_section_users = /** @type {((inputs?: Project_Access_Conflicts_Section_UsersInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Access_Conflicts_Section_UsersInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nutzer mit fehlendem Zugriff")
	return /** @type {LocalizedString} */ ("Users with Missing Access")
});